import { render } from "./clinic-timeline.vue?vue&type=template&id=408955c9&scoped=true"
import script from "./clinic-timeline.vue?vue&type=script&lang=js"
export * from "./clinic-timeline.vue?vue&type=script&lang=js"

import "./clinic-timeline.vue?vue&type=style&index=0&id=408955c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408955c9"]])

export default __exports__